import { render } from "./ListTeachers.vue?vue&type=template&id=a45c816a&scoped=true"
import script from "./ListTeachers.vue?vue&type=script&lang=js"
export * from "./ListTeachers.vue?vue&type=script&lang=js"

import "./ListTeachers.vue?vue&type=style&index=0&id=a45c816a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a45c816a"]])

export default __exports__